module.exports = __webpack_public_path__ + "media/images/map-header-icon-1aa7b5f0a30aa88f81e7d43edf044fd1.svg";